var states = [
    ['AL', 'Alabama'],
    ['MT', 'Montana'],
    ['AK', 'Alaska'],
    ['NE', 'Nebraska'],
    ['AZ', 'Arizona'],
    ['NV', 'Nevada'],
    ['AR', 'Arkansas'],
    ['NH', 'New Hampshire'],
    ['CA', 'California'],
    ['NJ', 'New Jersey'],
    ['CO', 'Colorado'],
    ['NM', 'New Mexico'],
    ['CT', 'Connecticut'],
    ['NY', 'New York'],
    ['DE', 'Delaware'],
    ['NC', 'North Carolina'],
    ['FL', 'Florida'],
    ['ND', 'North Dakota'],
    ['GA', 'Georgia'],
    ['OH', 'Ohio'],
    ['HI', 'Hawaii'],
    ['OK', 'Oklahoma'],
    ['ID', 'Idaho'],
    ['OR', 'Oregon'],
    ['IL', 'Illinois'],
    ['PA', 'Pennsylvania'],
    ['IN', 'Indiana'],
    ['RI', 'Rhode Island'],
    ['IA', 'Iowa'],
    ['SC', 'South Carolina'],
    ['KS', 'Kansas'],
    ['SD', 'South Dakota'],
    ['KY', 'Kentucky'],
    ['TN', 'Tennessee'],
    ['LA', 'Louisiana'],
    ['TX', 'Texas'],
    ['ME', 'Maine'],
    ['UT', 'Utah'],
    ['MD', 'Maryland'],
    ['VT', 'Vermont'],
    ['MA', 'Massachusetts'],
    ['VA', 'Virginia'],
    ['MI', 'Michigan'],
    ['WA', 'Washington'],
    ['MN', 'Minnesota'],
    ['WV', 'West Virginia'],
    ['MS', 'Mississippi'],
    ['WI', 'Wisconsin'],
    ['MO', 'Missouri'],
    ['WY', 'Wyoming'],
    ['DC', 'District of Columbia'],
    ['AS', 'American Samoa'],
    ['GU', 'Guam'],
    ['MP', 'Northern Mariana Islands'],
    ['PR', 'Puerto Rico'],
    ['VI', 'U.S. Virgin Islands'],
    ['AA', 'Armed Forces the Americas'],
    ['AE', 'Armed Forces Europe'],
    ['AP', 'Armed Forces Pacific']
];
var STATE_SELECTION_ITEMS = states
    .sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
})
    .map(function (s) {
    return { label: "".concat(s[0], " - ").concat(s[1]), value: s[0] };
});
export default STATE_SELECTION_ITEMS;
//# sourceMappingURL=statesItems.js.map